<template src="./EmployerCreateComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, onMounted, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useRoute} from "vue-router";
import {useStore} from "@/stores/store.js";
import {useAccountStore} from "@/stores/account.js";
import InputPasswordNormal from "@/components/inputs/input-password/normal/InputPasswordNormal.vue";
import InputDateTimeNormal from '@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue';
import {useEmployerStore} from "@/stores/employer.js";
import ErrorMessageService from "@/services/error-message.service.js";

export default {
  name: 'EmployerCreateComponent',
  components: {
    InputPasswordNormal,
    InputTextareaNormal,
    InputDateTimeNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const errors = ref(true)
    const errorMessage = ref([])
    const mode = ref('create')
    const labelButtonSetting = ref('Thêm Mới')
    const dataRegister = ref({
      user_name: {
        id: 'user_name',
        label: 'Tên nhân viên',
        placeholder: 'Tên nhân viên',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      employer_role: {
        id: 'employer_role',
        label: 'Chức Vụ',
        placeholder: 'Chức Vụ',
        value: '8',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: []
      },
      user_phone: {
        id: 'user_phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      user_email: {
        id: 'user_email',
        label: 'Email',
        placeholder: 'Email cá nhân',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      user_gender: {
        id: 'user_gender',
        label: 'Giới tính',
        placeholder: 'Giới tính',
        value: '1',
        error: '',
        isError: false,
        required: true,
        options: [
          {
            name: 'Nam',
            value: '1'
          },
          {
            name: 'Nữ',
            value: '2'
          },
          {
            name: 'Khác',
            value: '3'
          }
        ]
      },
      user_birthday: {
        id: 'user_birthday',
        label: 'Ngày sinh',
        placeholder: 'Ngày sinh',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      user_addr: {
        id: 'user_addr',
        label: 'Địa chỉ',
        placeholder: 'Địa chỉ',
        value: '',
        error: '',
        isError: false,
        required: true
      },
    })
    const route = useRoute()
    const storeCompStore = useStore()
    const accountStore = useAccountStore()
    const employerStore = useEmployerStore()

    onMounted(() => {
      getListStore();
      mode.value = route.params.mode;
      getAllowedRoles();
    });

    async function getListStore() {
      const params = {
        company_id: accountStore.account.company.id,
        m_user_id: CommonService.getUserId(),
      }

      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-store-by-role';
      await storeCompStore.getListStoreByRole(url, params);
    }

    async function getAllowedRoles() {
      const url = AppConstant.URL_API_LOCAL + 'api/v1/employer/allowed-create';
      const params = {
        company_id: accountStore.account.company.id,
        m_user_id: CommonService.getUserId(),
      };

      await employerStore.getAllowedRoles(url, params);
    }

    watch(
        () => employerStore.allowedRoles,
        (newAllowedRoles) => {
          if (newAllowedRoles && Array.isArray(newAllowedRoles)) {
            dataRegister.value.employer_role.options = newAllowedRoles;
            dataRegister.value.employer_role.value = newAllowedRoles[0]?.value || '';
          }
        },
        { immediate: true }
    );

    watch(() => storeCompStore.storeByRoles, (newListStores) => {
      if(newListStores.length) {
        newListStores.forEach((item) => {
          dataRegister.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
    });

    function onChange(value, name) {
      dataRegister.value[name].value = value
    }

    function validateForm(value, name) {
      if(name === 'user_name') {
        dataRegister.value.user_name.isError = false;
        dataRegister.value.user_name.error = ''
        errors.value = false
        if(!value) {
          dataRegister.value.user_name.isError = true;
          dataRegister.value.user_name.error = ErrorText.REQUIRED(dataRegister.value.user_name.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_TEXT) {
          dataRegister.value.user_name.isError = true;
          dataRegister.value.user_name.error = ErrorText.MAX_LENGTH(dataRegister.value.user_name.label, AppConstant.MAX_LENGTH_TEXT);
          errors.value = true
        }
      }

      if(name === 'employer_role') {
        dataRegister.value.employer_role.isError = false;
        dataRegister.value.employer_role.error = ''
        errors.value = false
        if(!value) {
          dataRegister.value.employer_role.isError = true;
          dataRegister.value.employer_role.error = ErrorText.REQUIRED(dataRegister.value.employer_role.label);
          errors.value = true
        }
      }

      if(name === 'user_phone') {
        dataRegister.value.user_phone.isError = false;
        dataRegister.value.user_phone.error = ''
        errors.value = false
        if(!value) {
          dataRegister.value.user_phone.isError = true;
          dataRegister.value.user_phone.error = ErrorText.REQUIRED(dataRegister.value.user_phone.label);
          errors.value = true
        }
        if(!errors.value && ![10, 11].includes(value.length)) {
          dataRegister.value.user_phone.isError = true;
          dataRegister.value.user_phone.error = ErrorMessageConstant.ERROR_PHONE_LENGTH;
          errors.value = true
        }
      }
      if(name === 'user_email') {
        dataRegister.value.user_email.isError = false;
        dataRegister.value.user_email.error = ''
        errors.value = false
        if(!value) {
          dataRegister.value.user_email.isError = true;
          dataRegister.value.user_email.error = ErrorText.REQUIRED(dataRegister.value.user_email.label);
          errors.value = true
        }
        if(!errors.value && !CommonService.validateEmail(value)) {
          dataRegister.value.user_email.isError = true;
          dataRegister.value.user_email.error = ErrorMessageConstant.ERROR_MAIL_INVALID;
          errors.value = true
        }
        if(!errors.value && value.length > 254) {
          dataRegister.value.user_email.isError = true;
          dataRegister.value.user_email.error = ErrorText.MAX_LENGTH(dataRegister.value.user_email.label, 254);
          errors.value = true
        }
      }

      if(name === 'user_gender') {
        dataRegister.value.user_gender.isError = false;
        dataRegister.value.user_gender.error = ''
        errors.value = false
        if(!value) {
          dataRegister.value.user_gender.isError = true;
          dataRegister.value.user_gender.error = ErrorText.REQUIRED(dataRegister.value.user_gender.label);
          errors.value = true
        }
      }
      if(name === 'user_birthday') {
        dataRegister.value.user_gender.isError = false;
        dataRegister.value.user_gender.error = ''
        errors.value = false
        if(!value) {
          dataRegister.value.user_gender.isError = true;
          dataRegister.value.user_gender.error = ErrorText.REQUIRED(dataRegister.value.user_gender.label);
          errors.value = true
        }
      }
      if(name === 'user_addr') {
        dataRegister.value.user_addr.isError = false;
        dataRegister.value.user_addr.error = ''
        errors.value = false
        if(!value) {
          dataRegister.value.user_addr.isError = true;
          dataRegister.value.user_addr.error = ErrorText.REQUIRED(dataRegister.value.user_addr.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_TEXT) {
          dataRegister.value.user_addr.isError = true;
          dataRegister.value.user_addr.error = ErrorText.MAX_LENGTH(dataRegister.value.user_addr.label, AppConstant.MAX_LENGTH_TEXT);
          errors.value = true
        }
      }

      if(name === 'store_id') {
        dataRegister.value.store_id.isError = false;
        dataRegister.value.store_id.error = ''
        errors.value = false
        if(!value && [6, 7, 8].includes(parseInt(dataRegister.value.employer_role.value))) {
          dataRegister.value.store_id.isError = true;
          dataRegister.value.store_id.error = ErrorText.REQUIRED(dataRegister.value.store_id.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_TEXT) {
          dataRegister.value.store_id.isError = true;
          dataRegister.value.store_id.error = ErrorText.MAX_LENGTH(dataRegister.value.store_id.label, AppConstant.MAX_LENGTH_TEXT);
          errors.value = true
        }
      }

    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }

    async function registerEmployer() {
      const storeId = dataRegister.value.store_id.value;
      if ([6, 7, 8].includes(parseInt(dataRegister.value.employer_role.value)) && (!storeId || storeId === '')) {
        validateForm(dataRegister.value.store_id.value, 'store_id')
      } else {
        if(!errors.value) {

          const params = {
            m_company_id: accountStore.account.company.id,
            user_name: dataRegister.value.user_name.value,
            m_role_id: dataRegister.value.employer_role.value,
            m_store_id: dataRegister.value.store_id.value,
            user_phone: dataRegister.value.user_phone.value,
            mail_address: dataRegister.value.user_email.value,
            user_gender: dataRegister.value.user_gender.value,
            user_birth: dataRegister.value.user_birthday.value,
            user_addr: dataRegister.value.user_addr.value,
          }
          const url = AppConstant.URL_API_LOCAL + 'api/v1/employer/register';
          const res = await employerStore.register(url, params);
          const errorMessageRes = await ErrorMessageService.getErrorMessage(res)

          if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
            errorMessage.value = errorMessageRes;
          }else {
            errorMessage.value = []

            await CommonService.showAlertPopup({
              title: res?.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1000,
              width: '800px'
            });
          }
        }
      }
    }

    return {
      dataRegister,
      mode,
      labelButtonSetting,
      CommonService,
      onChange,
      validateForm,
      checkSubmitActive,
      errorMessage,
      removeError,
      registerEmployer
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
